module.exports = __webpack_public_path__ + "images/mdj/members/resume/mobile/workhistory-b4bc8e7fba04e7a58385336eecddb8e0.png";